import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=48c4bf0d&"
import script from "./RadioButton.vue?vue&type=script&lang=js&"
export * from "./RadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports